import { useEffect } from "react";
import { IoMdClose } from 'react-icons/io';
import '../styles/modal.css'

const Modal2 = ({titulo = null, children, button = null, onClose, isOpen = null, bodyP = true, id = "modalBg", colorFondo = null }) => {
  useEffect(() => {
    const divModalSider = document.getElementById("modalS");
    const divModal = document.getElementById("modalBg");
    const modal = document.getElementById("modal");
  
    if (isOpen) {
      document.body.style.overflow = 'hidden';
  
      if (divModalSider) {
        divModalSider.style.display = 'inline-flex';
      }
      if (divModal) {
        divModal.style.display = 'inline-flex';
      }
      if (modal) {
        modal.style.display = 'block';
      }
    } else {
      document.body.style.overflow = 'unset';
  
      setTimeout(() => {
        if (divModal) {
          divModal.style.display = 'none';
        }
        if (divModalSider) {
          divModalSider.style.display = 'none';
        }
        if (modal) {
          modal.style.display = 'none';
        }
  
        divModalSider?.classList.remove('modalOut');
        divModal?.classList.remove('modalOut');
        modal?.classList.remove('out');
      }, 700);
    }
  }, [isOpen]);
  
  return (
    <div id={id} className={`contenedorModalGeneral ${isOpen == true ? "modalIn" : isOpen == false ? "modalOut" : null}`} onClick={onClose} >
      <div id="modal" className={`modalGeneral ${isOpen == 1 ? "in" : isOpen == 0 ? "out" : null}`} onClick={(e) => e.stopPropagation()} >
        {titulo && <div className='modalGeneralHeader' style={{ backgroundColor: "colorFondo" }}>
          {titulo}
          <div className='modalIcon'>
          <IoMdClose onClick={onClose} />
          </div>
        </div>}
        <div className={`modalGeneralBody ${bodyP ? "" : "paddingNull"}`}>
          {children}
        </div>
        {button &&
        <div className={button ? 'modalGeneralFooter' : 'modalGeneralFooter paddNull'}>
           {button}
        </div>          
        }
      </div>
    </div>
  )
}


export default Modal2;